import styled from '@emotion/styled'

export const DownloadLink = styled.a`
  visibility: hidden;
  position: absolute;
  top: 0;
  left: 0;
  pointer-events: none;
`
